import { Icon, List, ListItem, Stack, Text } from "@bookingcom/bui-react";
import { CheckmarkFillIcon } from "@bookingcom/bui-assets-react/streamline";
import { t, useI18n } from "@bookingcom/lingojs-react";
import { RECENT_PERIOD_MAPPINGS } from "../../../constants/date";
import type { RecentPeriod } from "../../../types/date";
import styles from "../DateRangePicker.module.css";

type DateRangePickerContentQuickSelectsProps = {
  quickSelect?: RecentPeriod;
  onQuickSelectChange?: (quickSelect: RecentPeriod) => void;
};

export const DateRangePickerContentQuickSelects = ({
  quickSelect,
  onQuickSelectChange = () => {},
}: DateRangePickerContentQuickSelectsProps) => {
  const i18n = useI18n();

  return (
    <Stack>
      <Text
        variant="strong_2"
        mixin={{ paddingBlockEnd: 3, paddingBlockStart: 3, paddingInlineEnd: 4, paddingInlineStart: 4 }}
      >
        {i18n.trans(t("flights_airline_portal_airline_view_page_overall_date_picker_header"))}
      </Text>
      <List aria-label="Quick date range selects">
        {RECENT_PERIOD_MAPPINGS.map(({ recentPeriod, noOfDays }) => {
          return (
            <ListItem
              key={`kQuickSelect-${recentPeriod}`}
              spacing="small"
              className={styles.quickSelectsListItem}
              onClick={() => onQuickSelectChange(recentPeriod)}
              aria-selected={recentPeriod === quickSelect}
            >
              <Stack direction="row" alignItems="center" gap={2}>
                <Text>
                  {i18n.trans(
                    t("flights_airline_portal_airline_view_page_overall_date_picker_options_days", {
                      variables: { num_days: noOfDays },
                    })
                  )}
                </Text>
                {recentPeriod === quickSelect && <Icon svg={CheckmarkFillIcon} />}
              </Stack>
            </ListItem>
          );
        })}
      </List>
    </Stack>
  );
};
